import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotiService } from 'src/app/services/noti.service';

@Component({
  selector: 'app-contact-us-form',
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.scss']
})
export class ContactUsFormComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-left iq-title-box-2',
    title: 'CONTACT_US',
    titleIcon: '',
    description: 'CONTACT_US_DESC'
  };
  @Input() notiForm: any={
    firstName:'',
    lastName:'',
    recipientEmail:'',
    phone:'',
    subject:'',
    notification:'',
    email:""
  };
  firstNameError:boolean=false;
  lastNameError:boolean=false;
  emailError:boolean=false;
  phoneError:boolean=false;
  subjectError:boolean=false;
  notiError:boolean=false
  constructor(
    public translate:TranslateService,
    public notiService:NotiService
  ) { }

  ngOnInit(): void {
  }
  public sendNoti():void{
    if(this.notiForm.firstName.trim()===''){
      this.firstNameError = true;
    }
    if(this.notiForm.lastName.trim()===''){
      this.lastNameError = true;
    }
    if(this.notiForm.recipientEmail.trim()===''){
      this.emailError = true;
    }
    if(this.notiForm.phone.trim()===''){
      this.phoneError = true;
    }
    if(this.notiForm.subject.trim()===''){
      this.subjectError = true;
    }
    if(this.notiForm.notification.trim()===''){
      this.notiError = true;
    }
    if(!this.firstNameError && !this.lastNameError  && !this.emailError && !this.phoneError && !this.subjectError && !this.notiError){
      console.log('notification sended with data', this.notiForm)
      this.notiForm.email= 'se2.tech@mail.se2.tech'
      this.notiService.sendMail(this.notiForm).subscribe((res)=>{
        console.log('res', res)
      })
    }
  }

}
